<div class="upload-modal-container">
    <!-- Header -->
    <div class="modal-header">
        <h2 mat-dialog-title>Editar imagem do produto</h2>
        <button type="button" class="oa-icon-btn close-button" (click)="cancel()" aria-label="Fechar" matTooltip="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Content -->
    <mat-dialog-content class="modal-content">
        <div class="product-info">
            <strong>{{ data.productName }}</strong>
        </div>

        <!-- Upload Component -->
        <div class="upload-section">
            <app-square-image-upload
                [productId]="data.productId"
                [imageUrl]="previewUrl"
                [productName]="data.productName"
                [editable]="true"
                [excludable]="false"
                (imageChanged)="onImageSelected($event)">
            </app-square-image-upload>
        </div>

        <div class="hint-text">
            Arraste uma imagem ou clique para selecionar
        </div>
    </mat-dialog-content>

    <!-- Actions -->
    <!-- Botões do DS: remover (danger-ghost, pede confirmação) à esquerda; Cancelar ghost + Salvar primary -->
    <mat-dialog-actions class="modal-actions">
        <button *ngIf="hasCurrentImage || previewUrl" type="button" class="oa-btn oa-btn--danger-ghost modal-actions__remove"
            (click)="removeImage()" [disabled]="isLoading">
            <mat-icon>delete_outline</mat-icon>
            <span>Remover imagem</span>
        </button>

        <button type="button" class="oa-btn oa-btn--ghost" (click)="cancel()" [disabled]="isLoading">
            Cancelar
        </button>

        <button type="button" class="oa-btn oa-btn--primary" (click)="save()" [disabled]="isLoading"
            [attr.aria-busy]="isLoading || null">
            <span>Salvar</span>
            <span *ngIf="isLoading" class="oa-spinner" aria-hidden="true"></span>
        </button>
    </mat-dialog-actions>
</div>
